import { isRegistrationOnboardingComplete } from '@/lib/registrationSnapshot';

/** Legacy DB/API role → platform role (keep in sync with web-service entity.NormalizeUserRole). */
export function normalizeApiRole(role) {
  if (role == null) return null;
  const r = String(role).trim();
  if (r === 'ADMIN_HALALIN' || r === 'AUDITOR_LPH') return 'SUPER_ADMIN';
  if (r === 'ANGGOTA') return 'TECHNICAL_ASSISTANT';
  return r;
}

/** @param {string|null|undefined} role */
export function hubPathForRole(role) {
  const r = normalizeApiRole(role);
  if (r === 'SUPER_ADMIN') return '/superadmin';
  if (r === 'TECHNICAL_ASSISTANT') return '/ta';
  if (String(role).trim() === 'AUDITOR') return '/auditor/documents';
  return '/dashboard';
}

/** Settings URL for API user role (client navbar / marketing bar). */
export function settingsPathForRole(role) {
  const r = normalizeApiRole(role);
  if (r === 'SUPER_ADMIN') return '/superadmin/settings';
  if (r === 'TECHNICAL_ASSISTANT') return '/ta';
  if (String(role).trim() === 'AUDITOR') return '/settings';
  return '/settings';
}

/**
 * @param {string|null|undefined} role
 * @param {string} fromPathname pathname from location.state.from or default
 * @param {string|null|undefined} paymentStatus PEMOHON: from GET /me `payment_status`; others ignored
 * @param {{ id?: string|null; email?: string|null; client_id?: string|null }|null|undefined} appUser PEMOHON: app user (or /me shape) for onboarding gate
 */
export function resolvePostLoginPath(role, fromPathname, paymentStatus, appUser) {
  const from = fromPathname || '/dashboard';
  const r = normalizeApiRole(role);

  if (r === 'TECHNICAL_ASSISTANT') {
    if (from.startsWith('/ta')) return from;
    if (from === '/documents') return '/ta/documents';
    if (from.startsWith('/superadmin')) return '/ta';
    return '/ta';
  }

  if (String(role).trim() === 'AUDITOR') {
    if (from.startsWith('/auditor')) return from;
    if (from === '/documents') return '/auditor/documents';
    if (from.startsWith('/superadmin')) return '/auditor/documents';
    return '/auditor/documents';
  }

  if (r === 'PEMOHON' && appUser && !isRegistrationOnboardingComplete(appUser)) {
    return '/onboarding';
  }

  if (r === 'PEMOHON' && paymentStatus !== 'VERIFIED') {
    return '/onboarding';
  }

  if (r === 'SUPER_ADMIN') {
    if (from.startsWith('/superadmin') || from === '/documents') return from;
    return '/superadmin';
  }

  if (from.startsWith('/superadmin')) return '/dashboard';

  return from;
}
